import React, { useState } from "react";
import FileInput from "@cloudscape-design/components/file-input";
import FileTokenGroup from "@cloudscape-design/components/file-token-group";
import SpaceBetween from "@cloudscape-design/components/space-between";

export default function StartComponent({ onBase64Change, value, setValue, error, setError }) {
  const [base64Files, setBase64Files] = useState([]);

  const handleFileChange = async ({ detail }) => {
    setError(false);
    
    // Append new files to existing ones
    const newFiles = [...value, ...detail.value];
    
    // Limit to 3 files
    const limitedFiles = newFiles.slice(0, 3);
    setValue(limitedFiles);

    if (limitedFiles.length > 0) {
      const filesPromises = limitedFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();

          reader.onload = (e) => {
            const base64WithPrefix = e.target.result;
            const base64Value = base64WithPrefix.split(",")[1];
            resolve({
              type: file.type,
              value: base64Value,
              name: file.name,
            });
          };

          reader.onerror = (error) => {
            console.error("Error reading file:", error);
            reject(error);
          };

          reader.readAsDataURL(file);
        });
      });

      try {
        const filesData = await Promise.all(filesPromises);
        setBase64Files(filesData);
        onBase64Change(filesData);
      } catch (error) {
        console.error("Error processing files:", error);
        setBase64Files([]);
        onBase64Change([]);
      }
    } else {
      setBase64Files([]);
      onBase64Change([]);
    }
  };

  const handleDismiss = (itemIndex) => {
    const newFiles = value.filter((_, index) => index !== itemIndex);
    setValue(newFiles);
    
    if (newFiles.length > 0) {
      const filesData = base64Files.filter((_, index) => index !== itemIndex);
      setBase64Files(filesData);
      onBase64Change(filesData);
    } else {
      setBase64Files([]);
      onBase64Change([]);
    }
  };

  return (
    <SpaceBetween size="s">
      <FileInput
        accept=".png, .jpeg, .jpg"
        onChange={handleFileChange}
        value={[]} // Always empty to allow adding more files
        multiple
        constraintText="Select 1-3 architecture diagrams (PNG/JPG). You can select multiple files at once. Max 5MB per file."
        errorText={error && "You must upload at least one architecture diagram before moving to the next step"}
      />
      {value.length > 0 && (
        <FileTokenGroup
          items={value.map((file, index) => ({
            file,
            dismissLabel: `Remove ${file.name}`,
          }))}
          onDismiss={({ detail }) => handleDismiss(detail.itemIndex)}
          showFileSize
          showFileLastModified
          showFileThumbnail
          i18nStrings={{
            limitShowFewer: "Show fewer files",
            limitShowMore: "Show more files",
            errorIconAriaLabel: "Error",
          }}
        />
      )}
    </SpaceBetween>
  );
}
